import React, { useState } from 'react';
import './App.css';
import Logo from './assets/logo.png'
import Gbsw from './assets/gbsw-logo.png'
import Byms from './assets/byms-logo.png'
import AppLogo from './assets/app-logo.png'
import { BrowserView, MobileView } from 'react-device-detect';

const App = () => {
  const [imageLoading, setImageLoading] = useState<boolean>(true)

  const handleClick = (url: string) => {
    window.location.href = `https://mileage.gbsw.hs.kr/${url}/`
  }

  return (
    <>
      <BrowserView>
        {
          imageLoading ?
            (
              <div className={'loading-background'}>
                <img src={Logo} alt={'image'} className={'logo'} onLoad={() => setImageLoading(false)}
                     style={{display: 'none'}}/>
              </div>
            ) : (
              <div className={'App'}>
                <div className={'container'}>
                  <img src={Logo} alt={'image'} className={'logo'}/>

                  <div className={'button-container'}>
                    <button onClick={() => handleClick('school')}>
                      <img src={Byms} alt={'byms-logo'} className={'byms-logo'}/>
                      <img src={Gbsw} alt={'gbsw-logo'} className={'gbsw-logo'}/>
                      그린 마일리지 이동
                    </button>
                  </div>

                  <div className={'button-container second-button-container'}>
                    <button onClick={() => handleClick('dormitory')}>
                      <img src={Gbsw} alt={'gbsw-logo'} className={'gbsw-logo'}/>
                      기숙사 상벌점 이동
                    </button>
                  </div>

                </div>
              </div>
            )
        }
      </BrowserView>

      <MobileView>
        <div className={'app-container'}>
          <div className={'app-box'}>
            <div className={'app-logo-container'}>
              <img src={AppLogo} className={'app-logo'}/>
            </div>

            <div className={'footer-button-container'}>
              <div className={'app-button-container'}>
                <button onClick={() => handleClick('school')} className={'school-btn'}>
                  <div className={'button-text'}>그린 마일리지 이동</div>
                </button>
              </div>

              <div className={'app-button-container'} style={{marginTop: '1rem', paddingBottom: '3rem'}}>
                <button onClick={() => handleClick('dormitory')} className={'dormitory-btn'}>
                  <div className={'button-text button-second-text'}>기숙사 상벌점 이동</div>
                </button>
              </div>

            </div>

          </div>
        </div>
      </MobileView>
    </>
  )
}

export default App;
